/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BpContact } from '../../models/bp-contact';

export interface FindBpContacts$Params {
  customerAccountId: number;
  addressId: number;
}

export function findBpContacts(http: HttpClient, rootUrl: string, params: FindBpContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BpContact>>> {
  const rb = new RequestBuilder(rootUrl, findBpContacts.PATH, 'get');
  if (params) {
    rb.path('customerAccountId', params.customerAccountId, {});
    rb.path('addressId', params.addressId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BpContact>>;
    })
  );
}

findBpContacts.PATH = '/business-parties/contacts/{customerAccountId}/{addressId}';
